import { AnalyticsBasePayload } from './events';

/**
 * The base payload of the page as it is right now.
 *
 * `clipboard.ts` and `visitOutcome.ts` are plain modules with no access to React state, but every
 * event has to carry `uuid` / `merchant` / `paymentMethod` / `template`. The page publishes the
 * payload here whenever the transaction changes, and those modules read it at emit time.
 *
 * Empty means "the page has not loaded a transaction yet" — events are dropped rather than sent
 * without their dimensions, since an event with no merchant cannot be sliced and only pollutes the
 * funnel.
 */
let context: AnalyticsBasePayload | null = null;

export const setAnalyticsContext = (payload: AnalyticsBasePayload): void => {
  context = payload;
};

export const getAnalyticsContext = (): AnalyticsBasePayload | null => context;

export const _resetContextForTests = (): void => {
  context = null;
};
